/* eslint-disable indent */
import React, {useMemo, useRef} from 'react';
import styled from 'styled-components';
import ReactSlider from '../../../../../../../Common/ReactSlider/ReactSlider';
import {useSelector} from 'react-redux';
import {getFormBodyDataBySectionId} from '../../../../../../../../selectors/Forms/formBodySelectors';

function AGGridSliderCellRenderer({data}) {
	const reactSliderRef = useRef();

	const formBodyData = useSelector((store) => getFormBodyDataBySectionId(store, data.compareSectionId));

	const body = useMemo(() => {
		if (Array.isArray(formBodyData)) {
			const found = formBodyData.find((body) => body.knowledgeId === Number(data.knowledgeFormBodyId));

			if (found) {
				return found;
			}
		}

		return null;
	}, [formBodyData, data]);

	const defaultSelectValue = useMemo(() => {
		if (data && body && data.knowledgeFormBodyOptionId) {
			const found = body.optionsAndResponses.find(
				(option) => option.knowledgeID === Number(data.knowledgeFormBodyOptionId)
			);

			if (found) {
				return {
					value: found.bodyOptionId,
					label: found.bodyOptionText
				};
			}
		}

		return null;
	}, [data, body]);

	if (body && defaultSelectValue) {
		return (
			<StyledAGGridSliderCellRenderer id={data.formBodyId} isOdd={data.rowType === 'odd'}>
				<ReactSlider
					max={body.optionsAndResponses[body.optionsAndResponses.length - 1].bodyOptionId}
					min={body.optionsAndResponses[0].bodyOptionId}
					value={body.optionsAndResponses}
					defaultValue={defaultSelectValue}
					bodyId={data.formBodyId}
					ref={reactSliderRef}
					StyleName={'ReactSliderBody'}
					aresSlider
					disabled
				/>
			</StyledAGGridSliderCellRenderer>
		);
	}

	return null;
}

export default AGGridSliderCellRenderer;

const StyledAGGridSliderCellRenderer = styled.section`
	display: flex;
	max-width: var(--px-500);
	margin: auto;
	margin-left: var(--px-10);
	margin-right: var(--px-10);

	.handleContainer {
		background-color: ${(props) => {
			return props.isOdd ? 'var(--neutrals-00white)' : 'var(--neutrals-25)';
		}};
	}

	.railStyle {
		background-color: var(--neutrals-700);
	}

	.tickSlider {
		background-color: var(--neutrals-700);
	}

	.tickSliderValue {
		color: var(--neutrals-700);
	}

	.handleSlider {
		color: var(--neutrals-900);
	}
`;
